import * as React from "react"
import Table from "@mui/material/Table"
import TableBody from "@mui/material/TableBody"
import TableCell, { tableCellClasses } from "@mui/material/TableCell"
import TableContainer from "@mui/material/TableContainer"
import TableHead from "@mui/material/TableHead"
import TableRow from "@mui/material/TableRow"
import Paper from "@mui/material/Paper"
import { styled } from "@mui/material/styles"

function createData(name, purpose, propia, information) {
  return { name, purpose, propia, information }
}

function createCookieData(name, category, information) {
  return { name, category, information }
}

const cookieRows = [
  createCookieData(
    "__Secure-1 PAPISID",
    "Publicitara / de segmentación",
    "Se utiliza para crear un perfil de los intereses del usuario y mostrar anuncios personalizados en función de su actividad en los sitios de Google."
  ),
  createCookieData(
    "__Secure-3 PAPISID",
    "Publicitara / de segmentación",
    "Se utiliza para ofrecer anuncios más relevantes y personalizados en función del historial de navegación y las interacciones del usuario."
  ),
  createCookieData(
    "__Secure-3 PSID",
    "Publicitara / de segmentación",
    "Permite mostrar anuncios personalizados en sitios de terceros, basados en los intereses del usuario y su comportamiento."
  ),
  createCookieData(
    "__Secure-3 PSIDCC",
    "Publicitara / de segmentación",
    "Ayuda a proteger la información del usuario, y también se utiliza para ofrecer anuncios más relevantes"
  ),
  createCookieData(
    "_fbp",
    "Publicitara / de segmentación",
    "Creada por Facebook Pixel para identificar y rastrear visitantes en distintos sitios web y mostrar anuncios relevantes."
  ),
  createCookieData(
    "_ga",
    "Analítica",
    "Identifica usuarios únicos mediante un ID generado aleatoriamente. Se usa para recopilar datos estadísticos de visitas y comportamiento."
  ),
  createCookieData(
    "_ga_JH18 P2J1DH",
    "Analítica",
    "Cookie asociada a Google Analytics 4 (GA4). Almacena un identificador único por propiedad para medir interacciones y sesiones."
  ),
  createCookieData(
    "_ga_T7ZH 5JE1GG",
    "Analítica",
    "Cookie asociada a Google Analytics 4 (GA4). Almacena un identificador único por propiedad para medir interacciones y sesiones."
  ),
  createCookieData(
    "_ga_YX48 DJPBL4",
    "Analítica",
    "Cookie asociada a Google Analytics 4 (GA4). Almacena un identificador único por propiedad para medir interacciones y sesiones."
  ),
  createCookieData(
    "_gcl_au",
    "Publicitaria / conversión",
    "Utilizada por Google AdSense / Ads para medir la eficacia de las campañas publicitarias (conversion tracking)."
  ),
  createCookieData(
    "_gid",
    "Analítica",
    "Registra un identificador único para generar estadísticas sobre cómoel visitante usa el sitio. Similar a _ga pero con menor duración."
  ),
];

const rows = [
  createData(
    "_ga",
    "Analiticas",
    "Externa (Google Analytics)",
    "Usada para diferenciar usuarios"
  ),
  createData(
    "_gat",
    "Analiticas",
    "Externa (Google Analytics)",
    "Limitar número de peticiones"
  ),
  createData(
    "_gid",
    "Analiticas",
    "Externa (Google Analytics)",
    "Usada para diferenciar usuarios"
  ),
  createData(
    "UserFrosting",
    "Auth/Session token",
    "Propio/a",
    "Identificar todos los requests pertenecientes a la misma sesión"
  ),
  createData(
    "1P_JAR",
    "Analytics",
    "Externa (Google Analytics) ",
    "Establecer una identificación única para acceder servicios g suite"
  ),
  createData("_cfduid", "Internas", "Externas (jQuery)", "Needed by jQuery"),
  createData(
    "_cfduid",
    "Seguridad",
    "Externa (Cloudflare)",
    "Identificar clientes individuales, para recordar configuraciones del usuario"
  ),
  createData(
    "_biz_flasgA",
    "Seguridad",
    "Externa (Cloudflare)",
    "Identificar clientes individuales, para recordar configuraciones del usuario"
  ),
  createData(
    "_biz_nA",
    "Seguridad",
    "Externa (Cloudflare)",
    "Identificar clientes individuales, para recordar configuraciones del usuario"
  ),
  createData(
    "_biz_flasgA",
    "Seguridad",
    "Externa (Cloudflare)",
    "Identificar clientes individuales, para recordar configuraciones del usuario"
  ),
  createData(
    "_biz_pendingA",
    "Seguridad",
    "Externa (Cloudflare)",
    "Identificar clientes individuales, para recordar configuraciones del usuario"
  ),
  createData(
    "_biz_uid",
    "Seguridad",
    "Externa (Cloudflare)",
    "Identificar clientes individuales, para recordar configuraciones del usuario"
  ),
  createData(
    "_mkto_trk",
    "Seguridad",
    "Externa (Cloudflare)",
    "Identificar clientes individuales, para recordar configuraciones del usuario"
  ),
]

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#36a7d4",
    color: theme.palette.common.white,
  },
}))

export default function TableCookies() {
  return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead>
          <TableRow>
            <StyledTableCell>Nombre</StyledTableCell>
            <StyledTableCell align="left">Categoría</StyledTableCell>
            <StyledTableCell align="left">Descripción / Propósito</StyledTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {cookieRows.map(row => (
            <TableRow
              key={row.name}
              sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
            >
              <StyledTableCell component="th" scope="row">
                {row.name}
              </StyledTableCell>
              <StyledTableCell align="left">{row.category}</StyledTableCell>
              <StyledTableCell align="left">{row.information}</StyledTableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  )
}
